
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PoCNRTVAppDialog extends Serenity.EntityDialog<PoCNRTVAppRow, any> {
        protected getFormKey() { return PoCNRTVAppForm.formKey; }
        protected getIdProperty() { return PoCNRTVAppRow.idProperty; }
        protected getLocalTextPrefix() { return PoCNRTVAppRow.localTextPrefix; }
        protected getNameProperty() { return PoCNRTVAppRow.nameProperty; }
        protected getService() { return PoCNRTVAppService.baseUrl; }
        protected getDeletePermission() { return PoCNRTVAppRow.deletePermission; }
        protected getInsertPermission() { return PoCNRTVAppRow.insertPermission; }
        protected getUpdatePermission() { return PoCNRTVAppRow.updatePermission; }

        protected form = new PoCNRTVAppForm(this.idPrefix);

        public diffunction: number;

        constructor() {
            super();
            (this.form.DtList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
                

            });




        }
        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            // if (this.isEditMode()) {
                

              
            let Approve: Serenity.ToolButton =
            {
                title: "Confirm",
                hint: "Approve",
                separator: false,
                cssClass: "bt-approve",
                // icon: "fa fa-save",
                // hotkey: 'alt+x',
                onClick: (e) => {
                    Q.confirm('ยืนยันบันทึก', () => {

                        // this.form.AppList.Appfg = 1;
                        var options = this.getSaveOptions((respons2) => {

                            if (this.isEditMode()) {
                                var id1 = respons2.EntityId;
                                if (id1 == null) {
                                    id1 = this.get_entityId();
                                }
                                this.loadById(id1);
                            }
                            else {
                                this.loadById(respons2.EntityId);
                                // this.dialogClose();
                            }

                            this.showSaveSuccessMessage(respons2);


                        });



                        options.onError = function (respons2) {
                            Q.alert(respons2.Error.Message);
                        }

                        Q.serviceCall(options);




                    });


                    
                }
            };
            buttons.push(Approve);

           

            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );


           

            return buttons;


        }

    

        protected afterLoadEntity() {
            super.afterLoadEntity();

          
            this.syscuscheck();

         



            ////----
            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            // self.element.find(".panel-titlebar").html("");
                            //self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".panel-titlebar").length == 1) {
                            // self.element.parent().find(".panel-titlebar").html("");
                            // self.element.parent().find(".panel-titlebar-text").html("");
                            self.element.parent().find(".panel-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 100);
            })();

            if (this.entity.ApproveFg == 1 || this.entity.ApproveFg == 2 || this.entity.CancelFg == 1) {
                this.toolbar.findButton('delete-button').hide();
                this.toolbar.findButton('button-sendapp').hide();
                this.toolbar.findButton('button-save').hide();
                this.toolbar.findButton('apply-changes-button').toggleClass('disabled', false);
                this.toolbar.findButton('bt-approve').hide();
                this.toolbar.findButton('bt-reject').hide();
                this.toolbar.findButton('bt-Return').hide();
                // this.form.DtList.Appfg = true
                this.form.DtList.set_readOnly(true);
                this.appreadonly()
            } if (this.entity.SendForAppfg == 1) {
                // this.form.DtList.Appfg = true
                this.toolbar.findButton('delete-button').hide();
                this.toolbar.findButton('button-sendapp').hide();
                this.toolbar.findButton('button-save').hide();
                this.toolbar.findButton('apply-changes-button').toggleClass('disabled', false);
                this.form.DtList.set_readOnly(true);
                this.appreadonly()



            } else {
                // this.form.DtList.Appfg = false


            }

        }

        private appreadonly() {
            // this.form.PurDocNo.set_readOnly(true);
            Serenity.EditorUtils.setReadOnly(this.form.TaxInvoiceNo, true);
            Serenity.EditorUtils.setReadOnly(this.form.DocDate, true);
            Serenity.EditorUtils.setReadOnly(this.form.SupplierId, true);
            Serenity.EditorUtils.setReadOnly(this.form.RefDocNo1, true);
            Serenity.EditorUtils.setReadOnly(this.form.RefDocNo2, true);
            Serenity.EditorUtils.setReadOnly(this.form.ShipId, true);
            Serenity.EditorUtils.setReadOnly(this.form.WhsId, true);
            Serenity.EditorUtils.setReadOnly(this.form.PayTermCode, true);
            Serenity.EditorUtils.setReadOnly(this.form.VatFg, true);
            Serenity.EditorUtils.setReadOnly(this.form.SalesVatTypes, true);
            Serenity.EditorUtils.setReadOnly(this.form.TaxInvoiceDate, true);

            Serenity.EditorUtils.setReadOnly(this.form.Remark, true);
            Serenity.EditorUtils.setReadOnly(this.form.DiscText, true);
            Serenity.EditorUtils.setReadOnly(this.form.VatCode, true);

            Serenity.EditorUtils.setReadOnly(this.form.CashOrTermfg, true);
            Serenity.EditorUtils.setReadOnly(this.form.DepositAmt, true);

            Serenity.EditorUtils.setReadOnly(this.form.DueDate, true);
            Serenity.EditorUtils.setReadOnly(this.form.ChequeNo, true);
            Serenity.EditorUtils.setReadOnly(this.form.PaymentType, true);
            Serenity.EditorUtils.setReadOnly(this.form.RefType, true);
            Serenity.EditorUtils.setReadOnly(this.form.PaymentDicsRemark, true);
            Serenity.EditorUtils.setReadOnly(this.form.PaymentDicsAmt, true);
            Serenity.EditorUtils.setReadOnly(this.form.ChequeDate, true);
            Serenity.EditorUtils.setReadOnly(this.form.BankId, true);
            Serenity.EditorUtils.setReadOnly(this.form.PaymentRefNo, true);
            Serenity.EditorUtils.setReadOnly(this.form.WhtAmt, true);
            Serenity.EditorUtils.setReadOnly(this.form.CurrencyCode, true);
            Serenity.EditorUtils.setReadOnly(this.form.ExchangeRate, true);
            Serenity.EditorUtils.setReadOnly(this.form.CurrencyAmt, true);

            Serenity.EditorUtils.setReadOnly(this.form.CusNetAmt, true);
            Serenity.EditorUtils.setReadOnly(this.form.CusVatAmt, true);
            Serenity.EditorUtils.setReadOnly(this.form.CusPurInvoiceAmt, true);
            Serenity.EditorUtils.setReadOnly(this.form.CusNetAmtDiff, true);
            Serenity.EditorUtils.setReadOnly(this.form.CusVatDiff, true);


            Serenity.EditorUtils.setReadOnly(this.form.CusCurrencyAmt, true);
            Serenity.EditorUtils.setReadOnly(this.form.CusCurrencyCode, true);
            Serenity.EditorUtils.setReadOnly(this.form.CusExchangeRate, true);
        }

        protected getSaveEntity(): PoCNRTVAppRow {
            let entity = super.getSaveEntity();

            return entity;
        }


        private getNextNumber() {
            var val = Q.trimToNull(this.form.SysDocNo.value);



            if (!val || val.length <= 3) {
                var someDate = new Date();
                var dd = someDate.getDate();
                var mm = someDate.getMonth() + 1;
                var myRow = 0;
                var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                // console.log('User Id : ' + userId.ShopId);

                // this.form.ShopId.value = userId.ShopId
                try {
                    var userRole = Q.first(Administration.UserRoleRow.getLookup().items, x => x.UserId == userId.UserId);

                    if (userRole != null) {
                        myRow = userRole.RoleId;
                    }
                    if (userRole != null || userRole.RoleId.valueOf) {
                        myRow = userRole.RoleId;
                    }
                    if (myRow == 1) {
                        //(this.form.SlmnCode.element as any).select2(userId.SlmnCode);
                    }
                } catch {

                }

                var y = someDate.getFullYear();
                var mo = "";
                var ddd = "";

                if (mm < 10) {
                    mo = '0' + mm;

                } else {
                    mo = mm.toString();
                }

                if (dd < 10) {
                    //ddd = '0' + dd;
                    ddd = '';

                } else {
                    //ddd = dd.toString();
                    ddd = '';
                }

                var someFormattedDate = y.toString().substr(2, 2);

                var docprefix = Q.tryFirst(Product.CsDocTypeRow.getLookup().items, x => x.DocType == "15").DocPrefix;
                var prefix = docprefix + userId.ShopId + someFormattedDate + mo + ddd;
                GeniuzPOS.Purchase.PoCNRTVAppService.GetNextNumber({
                    Prefix: prefix,
                    Length: 15
                }, response => {

                    this.form.SysDocNo.value = response.Serial;
                    this.form.PurIvNo.value = response.Serial;
                    this.form.DocDate.element.focus();
                });
            }

        }

    
        private syscuscheck() {
            let app = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 3 && x.SysFg > 0)
            console.log(app)
            if (app != null) {
                this.form.SalesVatTypes.getGridField().toggle(true);
            } else {
                this.form.SalesVatTypes.getGridField().toggle(false);
            }

            let vatfg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 64 && x.SysFg > 0)
            console.log(vatfg)
            if (vatfg != null) {
                this.form.VatFg.getGridField().toggle(true);
            } else {
                this.form.VatFg.getGridField().toggle(false);
            }
            let amtorvatdif = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 9 && x.SysFg > 0)
            console.log(amtorvatdif)
            if (amtorvatdif != null) {
                this.diffunction = 1;
                // this.diffg = false;

            } else {
                this.diffunction = 0
                this.form.CusNetAmt.getGridField().toggle(false);
                this.form.CusVatAmt.getGridField().toggle(false);
                this.form.CusPurInvoiceAmt.getGridField().toggle(false);
                this.form.CusNetAmtDiff.getGridField().toggle(false);
                this.form.CusVatDiff.getGridField().toggle(false);
            }
            let cur2 = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 10 && x.SysFg > 0)
            console.log(cur2)
            if (cur2 != null) {


            } else {
                this.form.CusCurrencyCode.getGridField().toggle(false);
                this.form.CusExchangeRate.getGridField().toggle(false);
                this.form.CusCurrencyAmt.getGridField().toggle(false);
            }
            let docdate = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 43 && x.SysFg > 0)
            // console.log(vatfg)
            if (docdate != null) {
                Serenity.EditorUtils.setReadOnly(this.form.DocDate, true);
            } else {

            }
            let hidePayment = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 39 && x.SysFg > 0)          

            if (hidePayment != null) {   
                // this.paymenthide   = 1            
                this.form.DepositAmt.getGridField().toggle(false);
                this.form.PaymentBeforeDisc.getGridField().toggle(false);
                this.form.PaymentType.getGridField().toggle(false);
                this.form.RefType.getGridField().toggle(false);
                this.form.PaymentDicsRemark.getGridField().toggle(false);
                this.form.PaymentDicsAmt.getGridField().toggle(false);

                this.form.ChequeNo.getGridField().toggle(false);
                this.form.ChequeDate.getGridField().toggle(false);
                this.form.PaymentAmt.getGridField().toggle(false);

                this.form.BankId.getGridField().toggle(false);
                this.form.PaymentRefNo.getGridField().toggle(false);
                this.form.WhtAmt.getGridField().toggle(false);

                this.form.CurrencyCode.getGridField().toggle(false);
                this.form.ExchangeRate.getGridField().toggle(false);
                this.form.CurrencyAmt.getGridField().toggle(false);

                this.form.PaymentNetAmt.getGridField().toggle(false);
                this.form.CusCurrencyCode.getGridField().toggle(false);
                this.form.CusExchangeRate.getGridField().toggle(false);
                this.form.CusCurrencyAmt.getGridField().toggle(false);
                this.form.ReceiptAmt.getGridField().toggle(false);
                this.form.BalanceAmt.getGridField().toggle(false);
               
            } else {
                // this.paymenthide   = 0
               
            }
            let extax = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 47 && x.SysFg > 0)
            console.log("extax"+extax)
            if (extax != null) {
                this.form.ExciseTaxAmt.getGridField().toggle(true);
                // this.form.VatFg.getGridField().toggle(true);
            } else {
                this.form.ExciseTaxAmt.getGridField().toggle(false);
                // this.form.VatFg.getGridField().toggle(false);
            }
            let reftax = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 66 && x.SysFg > 0)
            // console.log(vatfg)
            if (reftax != null) {
                this.form.TaxInvoiceRef.getGridField().toggle(true);
            } else {
                this.form.TaxInvoiceRef.getGridField().toggle(false);
            }
            let potype = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 72 && x.SysFg > 0)          

            if (potype != null) {
                // this.potypefg = 1;
                this.form.POTypeFg.getGridField().toggle(true);
            } else {
                // this.potypefg = 0;
                this.form.POTypeFg.getGridField().toggle(false);
            }
        }

       

    }
}